import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { ISlimScrollOptions } from 'ng2-slimscroll';
import * as _ from 'lodash';

import { MessageEvent, SidemenuToCalendarEvent, OpenFrameEvent, HiddenFooter } from './../../shared/message.event';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { PrimecalendarService } from './../primecalendar.service';
import { AppService } from '../../app.service';
import { LoaderEvent } from './../../shared/message.event';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
  selector: 'unblock-block-date',
  templateUrl: './unblock-date.component.html',
  styleUrls: ['./unblock-date.component.css'],
  providers: [PrimecalendarService, MessageEvent, LoaderEvent, OpenFrameEvent, UtilityFunctions],
  exportAs: 'unblockDates'
})
export class UnblockBlockDateComponent implements OnInit {

  private stringConstants = CONSTANT_MESSAGES;
  private vendor;
  private facility;
  private holidays = [];
  private facilityHolidays;
  private message = '';
  private count = 0;
  private windowHeight = window.innerHeight;
  private topNav = 56;
  private midNav = 45;
  private footer = 35;
  private container = 20;
  private height: any;
  private divHeight = 30;
  private unblockdate = 80;
  private facilityList = [];
  private multiselect = [];
  private allSelect = false;
  private minDate;
  private blockStartDate;
  private blockEndDate;
  private startMinDate;
  private endMinDate;
  private startMaxDate;
  private rangeList = [];
  private shouldSlide: boolean = false;
  private selectedFacility = '';
  private popUpMessage = '';
  private hideUpArrow = false;
  private hideDownArrow = false;
  private disableNewBookingsForSuperAdmin = false;
  private vendorId = '';
  private actionObj;
  private errorClass;
  private isOpen = false;
  private isopen2 = false;
  private unitName = 'All';
  private timezoneOffset;
  constructor(private loaderEvent: LoaderEvent, private router: Router, private messageEvent: MessageEvent, private sidemenuToCalendarEvent: SidemenuToCalendarEvent, private appService: AppService, private calendarService: PrimecalendarService, private openFrameEvent: OpenFrameEvent, private utilityFunctions: UtilityFunctions, private hiddenFooter: HiddenFooter) {
    this.height = (this.windowHeight - (this.topNav + this.midNav + this.container + this.footer + this.divHeight + this.unblockdate)) + 'px';
  }

  public showChildModal(facilityData): void {

  }

  public hideChildModal(): void {
  }

  ngOnInit() {
    if (localStorage.getItem('vendor')) {
      this.registerTypeBroadcast();
      this.emitOpenFrameEvent();
      this.emitTypeBroadcast();
      this.count = 0;
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
      this.timezoneOffset = this.vendor.timezoneOffset * -1;
      this.vendorId = this.vendor._id;
      //this.appService.getFacilityByClub(this.vendorId).then(result => {
      this.reset();
      this.minDate = ''
      this.rangeList = [];
      this.getFacility();
      this.makeBLockSlotListToDisplay();
      if (this.blockStartDate && this.blockEndDate) {
        this.sortDateWise();
        this.sortDataByDecending();
      }

      // });
    }
    if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {
      if (this.vendor.subVendors.length > 0) {
        let subVendor = this.vendor.subVendors[0];
        this.vendorId = subVendor._id;
      }
    } else if (this.vendor['role'] === CONSTANT_VALUES.ROLE_STAFF) {
      this.vendorId = this.vendor.vendorId;
    } else {
      this.vendorId = this.vendor._id
    }
    if (this.vendor['role'] === CONSTANT_VALUES.SUPER_ADMIN) {
      this.disableNewBookingsForSuperAdmin = true;
    }
  }

  emitTypeBroadcast() {
    let isShow = {
      privacypolicy: true,
      support: false,
      footer: 'block'
    };
    this.hiddenFooter.fire(isShow);
  }

  emitOpenFrameEvent() {
    this.openFrameEvent.fire(false);
  }
  ngOnDestroy() {
  }

  removeBlockSlot(holiday) {
    let that = this;
    if (holiday.isFullDay) {
      _.remove(this.facility.holidays, function (dataObj: any) {
        return holiday.date === dataObj.date && dataObj.isFullDay;
      });
    } else {
      if (this.facility && this.facility.holidays) {
        for (let i = 0; i < this.facility.holidays.length; i++) {
          if (this.facility.holidays[i].date === holiday.date) {
            _.remove(this.facility.holidays[i].slots, function (dataObj: any) {
              return dataObj.start && holiday.start === dataObj.start.replace(':00:00', '')
                && dataObj.end && dataObj.end.replace(':00:00', '') === holiday.end;
            });
          }
        }
        if (this.facility.holidays) {
          _.remove(this.facility.holidays, function (dataObj: any) {
            return !dataObj.isFullDay && dataObj.slots.length === 0;
          });
        }
        this.facilityList.map(function (facility) {
          if (facility._id === that.facility._id) {
            facility.holidays = _.cloneDeep(that.facility.holidays);
          }
          return facility;
        });
      } else {
      }
    }
    _.remove(this.holidays, function (ele) {
      return ele.count === holiday.count;
    });
    _.remove(this.rangeList, function (ele) {
      return ele.count === holiday.count;
    });
  }

  registerTypeBroadcast() {
    this.messageEvent.on()
      .subscribe(bool => {
        this.shouldSlide = bool;
      });
  }

  makeBLockSlotListToDisplay() {
    let that = this;
    let holidays = [];
    this.rangeList = [];
    that.holidays = [];
    let eleDate, dateObj;
    if (this.facility && this.facility.holidays && this.facility.holidays.length > 0) {
      holidays = _.cloneDeep(this.facility.holidays);
      holidays.forEach(element => {
        eleDate = element.date.split('/');
        dateObj = new Date(eleDate[2], eleDate[1] - 1, eleDate[0]);
        if (element.isFullDay) {
          that.count++;
          that.holidays.push({
            count: that.count,
            isFullDay: true,
            date: element.date,
            dateToShow: moment(element.date, 'DD/MM/YYYY').format('ll'),
            dateTemp: dateObj,
            start: that.facility.timings ? this.facility.timings.openTime.replace(/:00:00/g, '') : '',
            end: that.facility.timings ? that.facility.timings.closeTime.replace(/:00:00/g, '') : '',
            isChecked: false,
            unitNames: element['unitNames'].length >= this.facility.noOfUnits ? 'All' : element['unitNames']
          });
        } else {
          element.slots.forEach(ele => {
            that.count++;
            that.holidays.push({
              count: that.count,
              isFullDay: false,
              date: element.date,
              dateToShow: moment(element.date, 'DD/MM/YYYY').format('ll'),
              dateTemp: dateObj,
              start: ele.start ? ele.start.replace(/:00:00/g, '') : '',
              end: ele.end ? ele.end.replace(/:00:00/g, '') : '',
              isChecked: false,
              unitNames: element['unitNames'].length >= this.facility.noOfUnits ? 'All' : element['unitNames']
            });
          });
        }
      });
      this.message = '';
      this.rangeList = _.cloneDeep(that.holidays);
      console.log(this.rangeList);
    } else {
      this.message = CONSTANT_MESSAGES.NO_BLOCKED_SLOTS_ERROR_MSG;
    }
    this.sortDataByDecending();
  }

  unblockSlots() {
    let req = {
      vendorId: this.vendorId,
      facilityData: [{
        facilityId: this.facility._id,
        name: this.facility.name,
        timezoneOffset: this.vendor.timezoneOffset,
        timings: this.facility.timings,
        holidays: this.facility.holidays
      }]
    };
    this.loaderEvent.fire(false);
    this.appService.unblockDates(req).then((result: any) => {
      if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
        this.refillFacility();
        this.allSelect = false;
        this.multiselect = [];
        this.loaderEvent.fire(true);
      } else {
        this.loaderEvent.fire(true);
      }
    });
  }

  openUnblockDates(popup) {
    popup.showChildModal();
  }

  getFacility() {
    let that = this;
    that.facilityList = [];
    let selectedFacility = JSON.parse((localStorage.getItem('summaryViewRequest'))) ? JSON.parse((localStorage.getItem('summaryViewRequest'))) : {};
    let facilityData = [];
    if (localStorage.getItem('vendor_facilityData')) {
      facilityData = JSON.parse((localStorage.getItem('vendor_facilityData')));
    }
    facilityData.forEach(data => {
      data.data.forEach(facility => {
        facility.unitNames.push('All');
        that.facilityList.push(facility);
        if (!that.facility) {
          that.facility = facility._id == selectedFacility.facilityId || facility._id == selectedFacility._id ? facility : '';
          that.selectedFacility = that.facility;
        }
      })
    });
  }

  selectAll() {
    if (this.allSelect) {
      this.rangeList.map(function (ele: any) {
        ele.isChecked = true;
        return ele;
      })
      this.multiselect = _.cloneDeep(this.rangeList);
    } else {
      this.rangeList.map(function (ele: any) {
        ele.isChecked = false;
        return ele;
      })
      this.multiselect = [];
    }

  }

  addInMultiList(e, item) {
    if (e.target.checked) {
      this.multiselect.push(item);
    } else {
      this.allSelect = false;
      _.remove(this.multiselect, function (ele) {
        return ele.count == item.count;
      });
    }
  }

  unBlockMultipleSlots(flag, popupObj) {
    if (flag) {
      if (this.multiselect.length > 0) {
        this.multiselect.forEach(element => {
          this.removeBlockSlot(element);
        });
        this.unblockSlots();
        if (!this.rangeList.length) {
          this.message = CONSTANT_MESSAGES.NO_BLOCKED_SLOTS_ERROR_MSG;
        } else {
          this.message = '';
        }
      } else {
        this.popUpMessage = CONSTANT_MESSAGES.ATLEAST_ONE_BLOCK_SLOT;
        popupObj.showChildModal();
      }
    } else {

    }
  }

  removePerticularSlot(event) {
    if (event) {
      this.removeBlockSlot(this.actionObj);
      this.unblockSlots();
      if (!this.rangeList.length) {
        this.message = CONSTANT_MESSAGES.NO_BLOCKED_SLOTS_ERROR_MSG;
      } else {
        this.message = '';
      }
    }
  }

  reset() {
    let timeZoneDate = moment().utcOffset(this.vendor.timezoneOffset * -1);
    let year = timeZoneDate.year(), month = timeZoneDate.month(), date = timeZoneDate.date(), hour = timeZoneDate.hour(), minutes = timeZoneDate.minutes();
    // this.blockStartDate = '';
    //this.blockEndDate = '';

    this.setDates();
    this.holidays = [];
    this.startMinDate = (new Date(year, month, date, hour, minutes));
    this.endMinDate = (new Date(year, month, date, hour, minutes));
    this.minDate = (new Date(year, month, date, hour, minutes));
    this.startMaxDate = '';
  }

  changeEndMinDate(startDate) {
    this.endMinDate = startDate;
  }
  changeStartEndDate(minEndDate) {
    this.startMaxDate = minEndDate;
  }

  sortDateWise(popupObj?) {
    let eleDate, dateObj;
    let that = this;
    this.rangeList = [];
    if (this.blockStartDate && this.blockEndDate) {
      let calendarStartDate = new Date(that.blockStartDate);
      let calendarEndDate = new Date(that.blockEndDate);
      calendarStartDate.setHours(0, 0, 0, 0);
      calendarEndDate.setHours(24, 0, 0, 0);
      if (calendarStartDate < calendarEndDate) {
        this.rangeList = this.holidays.filter(function (rec: any) {
          if (calendarStartDate <= new Date(rec.dateTemp) && new Date(rec.dateTemp) < calendarEndDate) {
            if (that.unitName === 'All') {
              return rec;
            } else {
              if (rec.unitNames.indexOf(that.unitName) >= 0) {
                return rec;
              }
            }
          }
        });
        if (this.rangeList.length == 0) {
          this.message = CONSTANT_MESSAGES.NO_BLOCKED_SLOTS_ERROR_MSG;
        } else {
          this.message = '';
        }
      } else {
        if (popupObj) {
          this.popUpMessage = CONSTANT_MESSAGES.CALENDAR_DATE_LESS_ERROR_MSG;
          popupObj.showChildModal();
        }
      }
    } else {
      if (popupObj) {
        this.popUpMessage = CONSTANT_MESSAGES.DATE_NOT_VALID;
        popupObj.showChildModal();
      }
    }
  }

  sortDataByDecending() {
    this.rangeList.sort(function (a: any, b: any) {
      a = new Date(a.dateTemp);
      b = new Date(b.dateTemp);
      return a > b ? -1 : a < b ? 1 : 0;
    });

  }

  sortDataByAcending() {
    this.rangeList.sort(function (a: any, b: any) {
      a = new Date(a.dateTemp);
      b = new Date(b.dateTemp);
      return a < b ? -1 : a > b ? 1 : 0;
    });
  }

  facilityChange(item) {
    this.selectedFacility = item;
    if (this.selectedFacility === '') {
      this.errorClass = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
    } else {
      this.isopen2 = true;
      this.errorClass = '';
      this.multiselect = [];
      this.allSelect = false;
      this.facility = _.cloneDeep(this.selectedFacility);
      this.makeBLockSlotListToDisplay();
      if (this.blockStartDate && this.blockEndDate) {
        this.sortDateWise();
        this.sortDataByDecending();
      }
    }
  }

  goToViewSummary() {
    this.router.navigate(['/viewsummary']);
  }


  homeScreen() {
    this.utilityFunctions.homeScreen(this);
  }

  refillFacility() {
    this.facility = '';
    let that = this;
    this.appService.getFacilityByClub(this.vendorId).then(result => {
      this.reset();
      this.rangeList = [];
      this.getFacility();
      this.makeBLockSlotListToDisplay();
    });
  }

  showConfirmationFOrUnblock(msgPopup, popupObj) {
    if (this.multiselect.length > 0) {
      this.popUpMessage = CONSTANT_MESSAGES.UNBLOCK_CONFIRMATION;
      msgPopup.showChildModal();
    } else {
      this.popUpMessage = CONSTANT_MESSAGES.ATLEAST_ONE_SLOT_UNLOCK;
      popupObj.showChildModal();
    }

  }

  showConfirmationPopupForSingleUnblock(msgPopup, item) {
    this.actionObj = item;
    this.popUpMessage = CONSTANT_MESSAGES.UNBLOCK_CONFIRMATION;;
    msgPopup.showChildModal();
  }

  setUnitName(unitName) {
    this.unitName = unitName;
  }
  setDates() {
    let timeZoneDate = moment().utcOffset(this.timezoneOffset);
    let year = timeZoneDate.year(), month = timeZoneDate.month(), date = timeZoneDate.date(), hour = 0, minutes = 0;
    this.blockStartDate = (new Date(year, month, date, hour, minutes));
    let eventstartDate = moment().add(5, 'days').utcOffset(this.timezoneOffset).set({ 'hour': 0, 'second': 0, 'minute': 0, 'millisecond': 0 });
    year = eventstartDate.year(), month = eventstartDate.month(), date = eventstartDate.date(), hour = eventstartDate.hour(), minutes = eventstartDate.minutes();
    this.blockEndDate = (new Date(year, month, date, hour, minutes));
  }
}



// WEBPACK FOOTER //
// ./src/app/primecalendar/unblock-date/unblock-date.component.ts